import logoImage from '@/assets/logo.png';
export function Logo() {
  return (
    <div className="flex justify-center">
      <img
        src={logoImage}
        alt="Project Short"
        className="object-contain w-48 h-20"
      />
    </div>
  );
}
